import React from 'react'
import Pricing from '../../Pricing'

function Products() {
    return (
        <div>
            <Pricing />
        </div>
    )
}

export default Products
